module.exports = __webpack_public_path__ + "files/2358ffd8ad8b7e22161641ae75a78ed8.png";